module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0 pt-0 mb-0 pb-0",
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Suchen",
      "single-line": "",
      "solo": "",
      "flat": "",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "dense": "",
      "height": _vm.sideHeight,
      "headers": _vm.headers,
      "items": _vm.bbrbbr,
      "search": _vm.search,
      "fixed-header": "",
      "hide-default-footer": "",
      "hide-default-header": _vm.$vuetify.breakpoint.xsOnly,
      "items-per-page": -1,
      "no-data-text": "Keine Kontakte vorhanden"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(ref) {
        var item = ref.item;

        return [_c('thead', [_c('tr', {
          staticClass: "hidden-sm-and-up"
        }, [_c('th', [_vm._v("Nachname")]), _vm._v(" "), _c('th', [_vm._v("Vorname")])])])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', {
          on: {
            "dblclick": function($event) {
              (_vm.bbr = item) && (_vm.showKontakt = true)
            }
          }
        }, [_c('td', {
          attrs: {
            "width": "30px"
          }
        }, [_c('v-icon', [_vm._v(_vm._s(item.bildAhnengalerie ? 'check' : 'close'))])], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "30px"
          }
        }, [_c('v-avatar', {
          attrs: {
            "color": "grey",
            "size": "28"
          }
        }, [(item.bildAhnengalerie) ? _c('v-img', {
          staticClass: "ma-4 profilbild",
          attrs: {
            "src": item.bildAhnengalerie200 ? item.bildAhnengalerie200 : item.bildAhnengalerie
          }
        }) : _c('v-icon', {
          attrs: {
            "dark": "",
            "small": ""
          }
        }, [_vm._v("person")])], 1)], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "30px"
          }
        }, [_c('v-icon', [_vm._v(_vm._s(item.bildAhnengalerie500 ? 'check' : 'close'))])], 1), _vm._v(" "), _vm._l((_vm.headers), function(header) {
          return (header.type !== 'fix') ? _c('td', {
            key: header.number
          }, [_vm._v(_vm._s(item[header.value]))]) : _vm._e()
        })], 2)]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('dialogKontakt', {
    attrs: {
      "visible": _vm.showKontakt,
      "bbr": _vm.bbr
    },
    on: {
      "update:visible": function($event) {
        _vm.showKontakt = $event
      },
      "close": function($event) {
        _vm.showKontakt = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf386976"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/ahnengalerie.vue
// module id = 807
// module chunks = 15